import { getProjects } from '@lib/api'
import { projectsKeys } from '@lib/keys'
import { useQuery } from '@tanstack/react-query'

export const useProjects = () => {
  return useQuery(projectsKeys.all, () => getProjects())
}
